import React from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";

const ErrorPopup = ({open, onHide, children}) => {

if (!open) return null;
  return (
    <>
      <Modal show={open} onHide={onHide}>
        <Modal.Header className="bg-danger" closeButton>
          <Modal.Title>Sorry!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>
                {children}
              </Form.Label>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default ErrorPopup;
